import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { CircularLoader } from '@/components/Layout/CircularLoader';
import { useGetTaskById } from '@/features/projects/hooks/tasks/useGetTaskById';
import { ShowTaskDetail } from '@/features/projects/components/projectPage/components/DetailProject/ShowTaskDetail';
import showDetailProjectStyles from '@features/projects/styles/showdetailproject.module.scss';
import { useGetAllProjects } from '@/features/projects/hooks/useGetAllProjects';
import { ITask } from '@/api/tasks/types';

interface Props {
  isOpen: boolean;
  taskId: string | null;
  onClose: () => void;
}

export const TaskDetailDrawer = ({ isOpen, taskId, onClose }: Props) => {
  const { 
    data: taskData, 
    isLoading: isLoadingTask, 
    isError: isErrorTask, 
    isSuccess: isSuccessTask 
  } = useGetTaskById(taskId ?? '');

  const { 
    data: projectsData, 
    isLoading: isLoadingProjects 
  } = useGetAllProjects();

  const project = projectsData?.data.find(p => p.id.toString() === taskData?.data.projectId);
  const projectName = project?.name || '';

  useEffect(() => {
    if (isErrorTask) {
      toast.error("Error al cargar los detalles de la tarea.");
      onClose();
    }
  }, [isErrorTask, onClose]);

  if (!isOpen) {
    return null;
  }
  
  const isLoading = isLoadingTask || (isSuccessTask && isLoadingProjects);

  if (isLoading) {
    return (
      <div className={`${showDetailProjectStyles["showdetailproject"]} ${showDetailProjectStyles["showdetailproject--open"]}`}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
          <CircularLoader />
        </div>
      </div>
    );
  }

  if (isErrorTask) {
    return null;
  }

  if (isSuccessTask && taskData?.data) {
    return (
      <ShowTaskDetail
        closeDetailProject={onClose}
        showTask={taskData.data}
        idproject={taskData.data.projectId}
        projectName={projectName}
        createTask={async () => { return {} as ITask; }}
      />
    );
  }

  return null;
}; 